import { FC } from 'react';
import { styled, Tooltip, TooltipProps } from '@mui/material';

import { Chip, ChipProps } from './Chip';
import { GeneralFlag } from './Flag';

export type FlagChipProps = Pick<ChipProps, 'color'> & {
  countryCode: string;
  countryString?: string;
  TooltipProps?: Omit<TooltipProps, 'children' | 'title'>;
};

const StyledChip = styled(Chip)`
  padding-left: ${({ theme }) => theme.spacing(0.5)};
`;

export const FlagChip: FC<FlagChipProps> = ({
  color,
  countryCode,
  countryString,
  TooltipProps: tooltipProps,
}) => (
  <Tooltip title={countryString} {...tooltipProps}>
    <StyledChip
      avatar={
        countryCode.length === 2 ? (
          <GeneralFlag country={countryCode} size='tiny' variant='circle' />
        ) : undefined
      }
      color={color}
      label={<code>{countryCode}</code>}
      size='small'
      variant='outlined'
    />
  </Tooltip>
);
